var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8512 11.3175C21.1196 9.7175 18.2504 4.5 12.0004 4.5C5.75041 4.5 2.88124 9.7175 2.14958 11.3175C2.05136 11.5319 2.00052 11.765 2.00052 12.0008C2.00052 12.2367 2.05136 12.4697 2.14958 12.6842C2.88124 14.2825 5.75041 19.5 12.0004 19.5C18.2504 19.5 21.1196 14.2825 21.8512 12.6825C21.9493 12.4683 22 12.2355 22 12C22 11.7645 21.9493 11.5317 21.8512 11.3175ZM12.0004 17C11.0115 17 10.0448 16.7068 9.22256 16.1573C8.40032 15.6079 7.75945 14.827 7.38101 13.9134C7.00258 12.9998 6.90356 11.9945 7.09649 11.0245C7.28941 10.0546 7.76562 9.16373 8.46488 8.46447C9.16414 7.7652 10.0551 7.289 11.025 7.09607C11.9949 6.90315 13.0002 7.00216 13.9138 7.3806C14.8275 7.75904 15.6084 8.3999 16.1578 9.22215C16.7072 10.0444 17.0004 11.0111 17.0004 12C16.9991 13.3257 16.4719 14.5967 15.5345 15.5341C14.5971 16.4715 13.3261 16.9987 12.0004 17Z",
    fill: "#101828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 15.3332C13.8418 15.3332 15.3342 13.8408 15.3342 11.9998C15.3342 10.1589 13.8418 8.6665 12.0008 8.6665C10.1599 8.6665 8.66751 10.1589 8.66751 11.9998C8.66751 13.8408 10.1599 15.3332 12.0008 15.3332Z",
    fill: "#101828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.49b09d60042b73ab07b7ca9757f1ab19.svg";
export { ForwardRef as ReactComponent };